import { useField } from "@unform/core";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useFormContext, useFormState } from "react-hook-form";

import Affix from "../../Components/Affix";
import HelpText from "../../Components/HelpText";
import * as S from "./styles";

// eslint-disable-next-line react/display-name
export const Core = forwardRef(({ gridArea, margin, ...props }, ref) => {
  const [value, setValue] = useState(props?.defaultValue);
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField } = useField(props?.name);
  const [state, setState] = useState();

  const methods = useFormContext();
  const { setFocus, control } = methods ? methods : {};

  const { errors } = methods
    ? useFormState({
        control,
      })
    : {};

  useEffect(() => {
    if (errors && errors[fieldName]) {
      setFocus(fieldName);
    }
  }, [errors]);

  useEffect(() => {
    if (props?.mask) {
      registerField({
        name: fieldName,
        ref: ref ? ref.current : inputRef.current,
        path: "value",
        setValue(ref, value) {
          setValue(value);
        },
        clearValue() {
          setValue("");
        },
        getValue() {
          return value;
        },
      });
    } else {
      registerField({
        name: fieldName,
        ref: ref ? ref.current : inputRef.current,
        path: "value",
      });
    }
  }, [fieldName, registerField, value, props.mask, ref]);

  useEffect(() => {
    if (props?.value) {
      setValue(props.value);
    }
  }, [props?.value]);

  const getInput = (mask) => {
    if (mask)
      return (
        <S.MaskedInputStyleStructure
          id={fieldName}
          ref={ref ? ref : inputRef}
          defaultValue={defaultValue}
          value={value}
          required={props?.required}
          size={props?.size}
          mask={mask}
          onChange={(e) => {
            setValue(e.target.value);
            props?.onChange && props?.onChange(e);
          }}
          {...props}
        />
      );

    return (
      <S.InputStylesStructure
        id={fieldName}
        ref={ref ? ref : inputRef}
        defaultValue={defaultValue}
        required={props?.required}
        size={props?.size}
        {...props}
      />
    );
  };

  return (
    <S.Wrapper {...props} gridArea={gridArea} margin={margin}>
      {props?.label && (
        <S.Label htmlFor={fieldName} size={props?.size}>
          {props?.label} {props?.required && <S.RequiredDot />}
        </S.Label>
      )}
      <S.InputWrapper state={state} {...props}>
        {props?.prefix && (
          <Affix
            prefix="true"
            {...props?.prefix}
            size={props?.size}
            disabled={props.disabled}
          />
        )}
        {getInput(props?.mask)}
        {props?.suffix && (
          <Affix
            suffix="true"
            {...props?.suffix}
            size={props?.size}
            disabled={props.disabled}
          />
        )}
      </S.InputWrapper>
      {errors && errors[fieldName] ? (
        <HelpText
          id={fieldName}
          text={errors[fieldName]?.message}
          size={props?.size}
          setState={setState}
        />
      ) : null}
    </S.Wrapper>
  );
});
